import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Master";
import getToken from "app/api/getToken";
import { IMaster } from "app/api/types/Masters";

export const UPLOAD_MASTER_DIPLOMA_REQUEST = "UPLOAD_MASTER_DIPLOMA_REQUEST";
export const UPLOAD_MASTER_DIPLOMA_SUCCESS = "UPLOAD_MASTER_DIPLOMA_SUCCESS";
export const UPLOAD_MASTER_DIPLOMA_FAIL = "UPLOAD_MASTER_DIPLOMA_FAIL";

export const uploadMasterDiploma = (data: any, masterId: number) => (
  dispatch: any
): any => {
  dispatch({ type: UPLOAD_MASTER_DIPLOMA_REQUEST });

  const token = getToken();

  return api
    .uploadMasterDiploma(token, data, masterId)
    .then((response: AxiosResponse) => {
      const master: IMaster = get(response, "data", {});
      dispatch({ type: UPLOAD_MASTER_DIPLOMA_SUCCESS, payload: master });

      return master;
    })
    .catch(err => {
      dispatch({
        type: UPLOAD_MASTER_DIPLOMA_FAIL,
        payload: get(err, "response.data.errors", {})
      });
      throw get(err, "response.data.errors", {});
    });
};
